<ion-content>
  <ng-container *ngIf="processConfig">
    <div class="container-evaluations" *ngIf="!divide360UsersLitByAreaEnabled">
      <app-360-evaluation-report
        [processConfig]="processConfig"
        [evaluations]="evaluations"
        [showMoreLess]="true"
      ></app-360-evaluation-report>
    </div>
    <div class="container-evaluations-by-area" *ngIf="divide360UsersLitByAreaEnabled">
        <div class="container-evaluations" *ngFor="let area of areas">
            <app-360-evaluation-report
                    [titleKey]="getText(area.globalizationConfig, 'title')"
                    [processConfig]="processConfig"
                    [evaluations]="evaluationByArea[area.areaId]"
                    [showMoreLess]="true"
            ></app-360-evaluation-report>
        </div>
    </div>
  </ng-container>

  <ng-container *ngIf="freeEvaluationMidYearConfig">
    <div id="FreeEvalMid" class="container-evaluations">
      <app-free-evaluation-report
        titleKey="performanceCycle.freeEvalMidYear"
        [processConfig]="freeEvaluationMidYearConfig"
        [evaluations]="freeEvaluationsMidYear"
        [showMoreLess]="true"
      ></app-free-evaluation-report>
    </div>
  </ng-container>

  <ng-container *ngIf="freeEvaluationEndYearConfig">
    <div id="FreeEvalEnd" class="container-evaluations">
      <app-free-evaluation-report
        titleKey="performanceCycle.freeEvalEndYear"
        [processConfig]="freeEvaluationEndYearConfig"
        [evaluations]="freeEvaluationsEndYear"
        [showMoreLess]="true"
      ></app-free-evaluation-report>
    </div>
  </ng-container>

  <ng-container *ngIf="processConfig && !hideExternalEvalFromManagerCard">
    <div class="container-evaluations">
      <app-360-evaluation-report
        [external]="true"
        [processConfig]="processConfig"
        [evaluations]="externalThreeSixtyEvaluations"
        [showMoreLess]="true"
      ></app-360-evaluation-report>
    </div>
  </ng-container>

  <ng-container *ngIf="externalFreeEvaluationsMidYear && !hideExternalEvalFromManagerCard">
    <div id="FreeEvalMid" class="container-evaluations">
      <app-free-evaluation-report
        titleKey="performanceCycle.externalFreeEvalMidYear"
        [processConfig]="freeEvaluationMidYearConfig"
        [evaluations]="externalFreeEvaluationsMidYear"
        [showMoreLess]="true"
      ></app-free-evaluation-report>
    </div>
  </ng-container>

  <ng-container *ngIf="freeEvaluationEndYearConfig && !hideExternalEvalFromManagerCard">
    <div id="FreeEvalEnd" class="container-evaluations">
      <app-free-evaluation-report
        titleKey="performanceCycle.externalFreeEvalEndYear"
        [processConfig]="freeEvaluationEndYearConfig"
        [evaluations]="externalFreeEvaluationsEndYear"
        [showMoreLess]="true"
      ></app-free-evaluation-report>
    </div>
  </ng-container>
    
  <ng-container *ngIf="getManagerEvaluation">
      <div id="ManagerEval" class="container-evaluations">
          <app-360-evaluation-report
                  titleKey="headEvaluation.managerEvaluation"
                  [processConfig]="processConfig"
                  [evaluations]="managerEvaluation"
                  [showMoreLess]="true"
          ></app-360-evaluation-report>
      </div>
  </ng-container>
</ion-content>

<ion-footer mode="ios">
  <ion-toolbar mode="ios">
    <ion-row>
      <ion-col size="12">
        <ion-button
          color="secondary"
          expand="block"
          mode="ios"
          (click)="dismiss()"
        >
          OK
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
